<div class="content-container">
    <div class="container-left">
          <div class="rack-container" [ngClass]="{'rack-container-empty' : shelfArr.length === 0, 'rack-container': shelfArr.length > 0}">
            <div class="shelf-container">
              <div *ngFor="let shelf of shelfArr.slice().reverse();let i = index" class="shelf-item">
                <h3>Baggage Compartment {{shelfArr.length - i}}</h3>
                <mat-form-field appearance="outline" class="shelf-field">
                  <mat-label>Clear width</mat-label>
                  <input matInput type="number" autoComplete="off" [ngModel]="shelf?.box?.width" (keypress)="integerOnly($event)" (ngModelChange)="shelf.box.width = $event" class="text-right">
                </mat-form-field>
                <mat-form-field appearance="outline" class="shelf-field">
                  <mat-label>Compartment height</mat-label>
                  <input matInput type="number" autoComplete="off" [ngModel]="shelf?.box?.height" (keypress)="integerOnly($event)" (ngModelChange)="shelf.box.height = $event" class="text-right">
                </mat-form-field>
                <mat-form-field appearance="outline" class="shelf-field">
                  <mat-label>Depth of compartment</mat-label>
                  <input matInput type="number" autoComplete="off" [ngModel]="shelf?.box?.length" (keypress)="integerOnly($event)" (ngModelChange)="shelf.box.length = $event" class="text-right">
                </mat-form-field>
              </div>
            </div>
          </div>
      </div>
    
      <div class="container-right">
        <div class="properties">
            <mat-form-field class="form-field">
              <mat-label>Amount of people</mat-label>
                <mat-select [value]="bed?.amountOfPeople"
                    (selectionChange)="changeAmountOfPeopleList($event.value)">
                    <mat-option class="select-without-checkbox" *ngFor="let capacity of amountOfPeopleList" [value]="capacity">
                        {{capacity}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="properties-buttons">
          <button mat-raised-button class="margin-right color" [disabled]="isRemoveShelfDisabled" (click)="removeShelf()">
            <mat-icon class="margin-right">remove</mat-icon>Remove Compartment
          </button>
          <button mat-raised-button class="margin-right color" (click)="addShelf()">
            <mat-icon class="margin-right">add_box</mat-icon>Add Compartment
          </button>
        </div>
      </div>
</div>